import React, { useState } from "react";
import { FieldValues, ValidationMode, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ObjectSchema } from "yup";
import { ObjectShape } from "yup/lib/object";

export const useHandleForm = (
  schema: ObjectSchema<ObjectShape> = undefined,
  defaultValues: FieldValues = undefined,
  initialFocus = undefined,
  mode: keyof ValidationMode = "onSubmit",
) => {
  const methods = useForm({
    mode,
    defaultValues,
    resolver: schema ? yupResolver(schema) : null,
  });
  const errors = methods.formState.errors;

  const [isFocused, setIsFocused] = useState(initialFocus);
  const watchAllField = methods.watch();

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>, field = null) => {
    const { name } = field ? field : e.target;
    setIsFocused({ ...isFocused, [name]: true });
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;

    if (watchAllField[name] !== "" && watchAllField[name] !== null) {
      setIsFocused({ ...isFocused, [name]: true });
    } else {
      setIsFocused({ ...isFocused, [name]: false });
    }
  };

  return {
    ...methods,
    handleBlur,
    handleFocus,
    errors,
    isFocused,
    setIsFocused,
    watchAllField,
  };
};
